"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarNotPermittedError = exports.AvatarDoesNotExistError = exports.default = void 0;
var AvatarsServiceClient_1 = require("./AvatarsServiceClient");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(AvatarsServiceClient_1).default; } });
var AvatarDoesNotExistError_1 = require("./errors/AvatarDoesNotExistError");
Object.defineProperty(exports, "AvatarDoesNotExistError", { enumerable: true, get: function () { return __importDefault(AvatarDoesNotExistError_1).default; } });
var AvatarNotPermittedError_1 = require("./errors/AvatarNotPermittedError");
Object.defineProperty(exports, "AvatarNotPermittedError", { enumerable: true, get: function () { return __importDefault(AvatarNotPermittedError_1).default; } });
//# sourceMappingURL=index.js.map